import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { withFlags } from '../../../flags/Flags';

import { AdvancedSettings, AssetSummary } from '../../components';

export class SettingsTab extends Component {
  render() {
    return withFlags(flags => {
      const assets = this.props.assets.data;
      const { summary } = assets;
      const chartRows = [
        {
          type: 'active',
          sum: summary.active
        },
        {
          type: 'expired',
          sum: summary.expired
        }
      ];
      return (
        <div className="dashboard-overview">
          {summary ? (
            <AssetSummary
              summary={summary}
              chartRows={chartRows}
              {...this.props}
              assets={assets}
              source="settings"
            />
          ) : null}
          <AdvancedSettings flags={flags} {...this.props} assets={assets} />
        </div>
      );
    });
  }
}

SettingsTab.propTypes = {
  actions: PropTypes.shape({
    getAttributes: PropTypes.func,
    openModal: PropTypes.func
  }),
  attributes: PropTypes.object.isRequired,
  modals: PropTypes.object,
  location: PropTypes.object
};

export default injectIntl(SettingsTab);
